export default __webpack_public_path__ + "static/media/press_room_thumb_modal2.dbbe6036.jpg";